<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14.1" height="20.053" viewBox="0 0 14.1 20.053">
    <g transform="translate(-76)">
      <g transform="translate(76)">
        <path
          d="M83.05,0a7.051,7.051,0,0,0-6,10.757l5.6,9.018a.587.587,0,0,0,.5.278h0a.587.587,0,0,0,.5-.286l5.454-9.106A7.051,7.051,0,0,0,83.05,0ZM88.1,10.058l-4.958,8.278-5.088-8.2A5.879,5.879,0,1,1,88.1,10.058Z"
          transform="translate(-76)"
          fill="#777"
        />
      </g>
      <g transform="translate(79.525 3.525)">
        <path
          d="M169.525,90a3.525,3.525,0,1,0,3.525,3.525A3.529,3.529,0,0,0,169.525,90Zm0,5.883a2.358,2.358,0,1,1,2.354-2.358A2.36,2.36,0,0,1,169.525,95.883Z"
          transform="translate(-166 -90)"
          fill="#777"
        />
      </g>
    </g>
  </svg>
</template>
